import { InputNumber, Space } from 'antd';
import BigNumber from 'bignumber.js';
import React, { useCallback, useEffect, useState } from 'react';
import { NumericKeyboardInput } from '@/components/NumericKeyboard';
import PosButton from '@/components/PosButton';
import { playSound } from '@/utils/sound';
import { message } from '@/components/Message';

function createSafeZeroTrimmer(initialInput: BigNumber.Value) {
  let current = new BigNumber(initialInput);
  const original = new BigNumber(initialInput);
  const highestDigit = original.integerValue(BigNumber.ROUND_FLOOR).toString()[0];

  return () => {
    // 去小数
    if (!current.isInteger()) {
      current = current.integerValue(BigNumber.ROUND_FLOOR);
      return current;
    }

    const digits = current.toFixed(0);
    for (let i = digits.length - 1; i > 0; i--) {
      if (digits[i] !== '0') {
        const newDigits = digits.slice(0, i) + '0'.repeat(digits.length - i);
        const newVal = new BigNumber(newDigits);
        if (newVal.toFixed(0)[0] === highestDigit) {
          current = newVal;
          return current;
        } else {
          break; // 已到最小安全位
        }
      }
    }

    return current;
  };
}

type Props = {
  beforeTotalPrice: BigNumber;
  // 使用积分
  value?: number;
  onChange?: (value: number) => void;
};

const WaiverAmountSelector: React.FC<Props> = ({ beforeTotalPrice, value, onChange }: Props) => {
  const [reset, setReset] = useState(0);
  const priceNum = beforeTotalPrice.toNumber();

  const autoWaiver = useCallback(createSafeZeroTrimmer(beforeTotalPrice.toNumber()), [
    beforeTotalPrice.toNumber(),
    reset,
  ]);

  const resetValue = () => {
    onChange(undefined);
    setReset(v => v + 1);
  };

  useEffect(() => {
    resetValue();
  }, [beforeTotalPrice.toNumber()]);

  return (
    <>
      <Space size={10} direction={'vertical'}>
        {priceNum > 0 && (
          <div>
            <Space size={10}>
              <NumericKeyboardInput
                value={value}
                inputType={InputNumber}
                onChange={v => {
                  if (!v) {
                    onChange(undefined);
                  } else {
                    if (+v > priceNum) {
                      onChange(priceNum);
                    } else {
                      onChange(+v);
                    }
                  }
                }}
                inputProps={{
                  placeholder: '减免金额',
                  style: { width: '100%' },
                  min: 0,
                  max: priceNum,
                  precision: 2,
                }}
                keyboardProps={{
                  parseValueToNumber: true,
                  precision: 2,
                  showAllClean: true,
                  placement: 'right',
                  trigger: 'click',
                  style: { width: 300 },
                }}
              />
              <PosButton
                onClick={() => {
                  const waiverAmount = beforeTotalPrice.minus(autoWaiver());
                  if (waiverAmount.gt(0)) {
                    onChange(waiverAmount.toNumber());
                  } else {
                    message.info('已无法抹零', 1);
                  }

                  playSound('click');
                }}>
                快速抹零
              </PosButton>
              <PosButton
                onClick={() => {
                  resetValue();
                  playSound('click');
                }}>
                重置
              </PosButton>
            </Space>
          </div>
        )}
      </Space>
    </>
  );
};

export default WaiverAmountSelector;
